import angular from 'angular';
import _ from 'underscore';

import config from 'src/config';

function UrlService($window, managementUserService, colorService) {
  class UrlServiceFn {

    /**
     * Takes an object, and adds those key/value
     * pairs as query parameters to the provided string.
     * ex: 'tl.com' + { param : value } => tl.com?param=value
     *
     * @method addQueryParams
     * @param {string} url - Base URL
     * @param {object} params - key values pairs for params to add
     */
    addQueryParams(url, params) { //eslint-disable-line
      if (!url) return '';
      if (!params) return url;

      // Remove undefined keys
      params = _.omit(params, function (value) {
        return (typeof value === 'undefined' || value === null);
      });

      // Add valid query params
      if (Object.keys(params).length > 0) {
        url += '?' + angular.element.param(params); //eslint-disable-line
      }

      return url;
    }

    /**
     * @param {String} seoPathname
     * @param {Object} [options]
     * @param {String} [options.attributionId]
     * @param {String} [options.attributionType]
     * @param {Object} [options.venue]
     * @return {String}
     */
    getEventPublicPageUrl(seoPathname, options = {}) {
      const currentUser = managementUserService.getCurrentUser();

      if (!currentUser) throw new Error('urlService - getEventPublicPageUrl() - currentUser does not exist');
      if (!seoPathname) throw new Error('urlService - getEventPublicPageUrl() - seoPathname required');

      let url = `${config.TABLELIST_WEBSITE_URL}/e/${seoPathname}`;
      const params = {};

      if (options.attributionId) params.attributionId = options.attributionId;
      if (options.attributionType) params.attributionType = options.attributionType;
      if (options.client) params.client = options.client;

      url = this.addQueryParams(url, params);

      if (options.venue) {
        if (options.venue.branding) {
          if (options.venue.branding.primaryColor) {
            let primaryHex = colorService.rgbToHex(options.venue.branding.primaryColor.red, options.venue.branding.primaryColor.green, options.venue.branding.primaryColor.blue);
            primaryHex = primaryHex.replace('#', '');
            url += `&hlcolor=${primaryHex}`;
          }
          if (options.venue.branding.secondaryColor) {
            let secondaryHex = colorService.rgbToHex(options.venue.branding.secondaryColor.red, options.venue.branding.secondaryColor.green, options.venue.branding.secondaryColor.blue);
            secondaryHex = secondaryHex.replace('#', '');
            url += `&bgcolor=${secondaryHex}`;
          }
        }
      }

      return url;
    }

    /**
     * @param {String} eventId
     * @return {String}
     */
    getEventTablelistPageUrl(eventId) { //eslint-disable-line
      const currentUser = managementUserService.getCurrentUser();

      if (!currentUser) throw new Error('urlService - getEventTablelistPageUrl() - currentUser does not exist');

      return `${config.TABLELIST_WEBSITE_URL}/event/${eventId}`;
    }

    getPublicVenueEventPageUrl(venueId) { //eslint-disable-line
      return `${config.TABLELIST_WEBSITE_URL}/v/${venueId}/events`;
    }
  }

  return new UrlServiceFn();
}

UrlService.$inject = [
  '$window',
  'jsSdk.managementUser',
  'colorService'
];

export default UrlService;



// WEBPACK FOOTER //
// ./src/services/urlService.js